import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#92989B"
      strokeWidth={1.33}
      d="m3.2 3.2 9.6 9.6M12.8 3.2l-9.6 9.6"
    />
  </svg>
);
export default SvgComponent;
